import * as React from 'react';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel='[class*="MuiDialogContent-root"]'>
            <Paper {...props} />
        </Draggable>
    );
}
export default PaperComponent;
